import {
  InternalApiEntitySchemaField,
  InternalApiScreeningFlow,
  InternalApiScreeningListType,
} from '../../../api-internal';
import { ApiSanctionType } from '../../../api';
import { UsableField } from '../steps/ScreenableDataStep';
import { ScreenableFieldCustomListConfiguration } from '../steps/ListSelectionStep';

const getType = (type: InternalApiScreeningListType): ApiSanctionType => {
  switch (type) {
    case InternalApiScreeningListType.PEP:
      return ApiSanctionType.PEP;
    case InternalApiScreeningListType.ADVERSE_MEDIA:
      return ApiSanctionType.ADVERSE_MEDIA;
    case InternalApiScreeningListType.ADVERSE_MEDIA_ENTITY:
      return ApiSanctionType.ADVERSE_MEDIA_ENTITY;
    case InternalApiScreeningListType.SANCTION:
    default:
      return ApiSanctionType.SANCTION;
  }
};

export const getUsableFields = (
  flow: InternalApiScreeningFlow,
  schemaFields: InternalApiEntitySchemaField[]
): UsableField[] => {
  const fields = flow.field.split(' ');
  const usableFields = fields.map((field: string) => {
    if (field.includes('.')) {
      const [parentField, childField] = field.split('.').map((it) => it.replace('[]', ''));
      const parentSchemaField = schemaFields.filter((it) => !it.parentId).find((it) => it.fieldName === parentField);
      const childSchemaField = schemaFields
        .filter((it) => it.parentId === parentSchemaField?.id)
        .find((it) => it.fieldName === childField);
      return childSchemaField
        ? {
            id: childSchemaField.id,
            fieldName: field,
          }
        : undefined;
    } else {
      const schemaField = schemaFields.filter((it) => !it.parentId).find((it) => it.fieldName === field);
      return schemaField
        ? {
            id: schemaField.id,
            fieldName: schemaField.fieldName,
          }
        : undefined;
    }
  });

  // if any usable field parts don't have a counterpart in the schema, return empty
  return usableFields.every((usableField) => usableField) ? (usableFields as UsableField[]) : [];
};

export const getDowJonesListTypes = (flow: InternalApiScreeningFlow): ApiSanctionType[] => {
  return (
    flow.lists?.filter((it) => it.type !== InternalApiScreeningListType.CUSTOM_LIST).map(({ type }) => getType(type)) ??
    []
  );
};

export const getCustomListTypes = (flow: InternalApiScreeningFlow): ScreenableFieldCustomListConfiguration[] => {
  return (
    flow.lists
      ?.filter(({ type }) => type === InternalApiScreeningListType.CUSTOM_LIST)
      .reduce((acc, { list, usableField }) => {
        const existing = acc.find((item) => item.list?.id === list.id);
        if (existing) {
          existing.fields.push({ id: usableField!.id!, name: usableField!.name! });
          return acc;
        } else {
          return [
            ...acc,
            {
              list: {
                id: list.id!,
                name: list.name,
              },
              fields: [
                {
                  id: usableField!.id,
                  name: usableField!.name,
                },
              ],
            },
          ] as ScreenableFieldCustomListConfiguration[];
        }
      }, [] as ScreenableFieldCustomListConfiguration[]) ?? []
  );
};
